import { render } from "./HomeVisitFalken.html?vue&type=template&id=fa1df502&scoped=true&ts=true&external"
import script from "./HomeVisitFalken.ts?vue&type=script&lang=ts&external"
export * from "./HomeVisitFalken.ts?vue&type=script&lang=ts&external"

import "./HomeVisitFalken.scss?vue&type=style&index=0&id=fa1df502&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1df502"]])

export default __exports__